/**
 * Converts a percentage string back to a number
 * E.g:
 * fromPercentageString('54.62%') = 54.62
 *
 * @param percentString - The percentage stringified value
 * @returns - The percentage value as a number
 */
export function fromPercentageString(percentString: string): number {
    const percentageOperatorIndex = percentString.indexOf('%');
    if (percentageOperatorIndex === -1) {
        throw new Error('Not a valid percentage string');
    }
    return parseFloat(percentString.slice(0, percentageOperatorIndex));
}
